<template>
  <div class="Challenge">
    <div id="form-div">
      <div class="row justify-content-center align-items-center px-3">
        <span>{{ $t('crosswalk.challenge.prompt') }}</span>

        <div class="col-md-9">
          <MDBRadio
              style="text-align:left"
              :label="$t('crosswalk.challenge.types.comprehensivePlan')"
              name="challengeType"
              v-model="challengeType"
              value="Comprehensive Plan"
              @blur="crosswalkChallengeStore.challengeTypeChanged"
              :disabled="!editMode"
          />
          <MDBRadio
              style="text-align:left"
              :label="$t('crosswalk.challenge.types.currentStrategicPlan')"
              name="challengeType"
              v-model="challengeType"
              value="Current Strategic Plan"
              @blur="crosswalkChallengeStore.challengeTypeChanged"
              :disabled="!editMode"
          />
          <MDBRadio
              :label="$t('crosswalk.challenge.types.implementationPlan')"
              name="challengeType"
              v-model="challengeType"
              value="Implementation Plan"
              @blur="crosswalkChallengeStore.challengeTypeChanged"
              :disabled="!editMode"
          />
          <MDBRadio
              :label="$t('crosswalk.challenge.types.sustainabilityPlan')"
              name="challengeType"
              v-model="challengeType"
              value="Sustainability Plan"
              @blur="crosswalkChallengeStore.challengeTypeChanged"
              :disabled="!editMode"
          />
          <MDBRadio
              :label="$t('crosswalk.challenge.types.other')"
              name="challengeType"
              v-model="challengeType"
              value="Other"
              @blur="crosswalkChallengeStore.challengeTypeChanged"
              :disabled="!editMode"
          />

          <MDBInput
              v-if="challengeType === 'Other'"
              :label="$t('crosswalk.challenge.otherPlanTypeLabel')"
              v-model="challengeTypeOther"
              style="width:80%"
              @blur="crosswalkChallengeStore.challengeTypeOtherChanged"
              :disabled="!editMode"
          />
        </div>

        <div class="row justify-content-center align-items-center">
          <div class="col-md-12">
            {{ $t('crosswalk.challenge.locationPrompt') }}
            <MDBInput
                :label="$t('crosswalk.challenge.locationLabel')"
                rows="1"
                v-model="geographicalLocation"
                @blur="crosswalkChallengeStore.geographicalLocationChanged"
                :disabled="!editMode"
            />
          </div>
        </div>

        <div class="row justify-content-center align-items-center">
          <div class="col-md-12">
            {{ $t('crosswalk.challenge.planUrlPrompt') }}
            <MDBTextarea
                label=""
                rows="1"
                v-model="planUrl"
                @blur="crosswalkChallengeStore.planUrlChanged"
                @change="crosswalkChallengeStore.planUrlChanged"
                :disabled="!editMode"
            />
          </div>
        </div>
      </div>
    </div>
  </div>

  <router-view />
</template>

<script src="./_ChallengeView.js" lang="js"></script>
<style src="./_ChallengeView.less" lang="less" scoped></style>
